import type { ConflictBadgeProps } from "./types-conflict-badge";
import { useConflictBadge } from "./use-conflict-badge";
import { ConflictBadgeView } from "./view-conflict-badge";

/** Tag laranja de conflito de alocação, com o detalhe no card de conflito. */
export function ConflictBadge(props: ConflictBadgeProps) {
  const vm = useConflictBadge(props);

  return <ConflictBadgeView {...vm} />;
}

export type * from "./types-conflict-badge";
